import { render } from "./AddFacture.vue?vue&type=template&id=d9e3f12c&ts=true"
import script from "./AddFacture.vue?vue&type=script&lang=ts"
export * from "./AddFacture.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__